/**
 * Utilidades para formateo de números siguiendo el estándar chileno.
 */

/**
 * Formatea un número al estilo chileno:
 * - Separador de miles: punto (.)
 * - Separador de decimales: coma (,)
 * 
 * @param value Valor numérico a formatear
 * @param decimals Número de decimales (por defecto 0)
 * @returns String formateado
 */
export function formatChileanNumber(
    value: number | string | undefined | null, 
    decimals: number = 0, 
    forceDecimals: boolean = false
): string {
    if (value === undefined || value === null || value === '') return '0';
    
    let num: number;
    if (typeof value === 'string') {
        // Si el string tiene coma como separador decimal (formato chileno), 
        // reemplazar punto de miles y usar coma como decimal
        const trimmed = value.trim();
        if (trimmed.includes(',') && trimmed.indexOf(',') > trimmed.lastIndexOf('.')) {
            // Formato chileno: "1.234,56" → "1234.56"
            num = parseFloat(trimmed.replace(/\./g, '').replace(',', '.'));
        } else {
            num = parseFloat(trimmed);
        }
    } else {
        num = value;
    }
    
    if (isNaN(num)) return '0';

    const dosPrimerosDecimalesSonCero = Math.abs(num % 1) < 0.01;
    const decimalesFinales = (dosPrimerosDecimalesSonCero && !forceDecimals) ? 0 : decimals;

    return new Intl.NumberFormat('es-CL', {
        minimumFractionDigits: decimalesFinales,
        maximumFractionDigits: decimalesFinales
    }).format(num);
}

/**
 * Formatea un porcentaje al estilo chileno (coma como separador decimal).
 * Acepta número o string con o sin sufijo %.
 */
export function formatChileanPercentage(
    value: number | string | undefined | null, 
    decimals: number = 2, 
    forceDecimals: boolean = false
): string {
    if (value === undefined || value === null || value === '') {
        return forceDecimals ? `0${decimals > 0 ? ',' + '0'.repeat(decimals) : ''}%` : '0%';
    }

    const raw = typeof value === 'string'
        ? value.replace('%', '').trim().replace(',', '.')
        : String(value);

    return `${formatChileanNumber(raw, decimals, forceDecimals)}%`;
}
